module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infromation"
  }, [_vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "card"
  }, [_c('div', [_c('md-input-container', [_c('label', [_vm._v("Rendezvény neve")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Leírás")]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "config": _vm.ckeditor
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h4', [_vm._v("Kapcsolati adatok")]), _vm._v(" "), _c('attachment-block', {
    attrs: {
      "attachments": _vm.form.attachments
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h4', [_vm._v("Szponzorok")]), _vm._v(" "), _vm._l((_vm.form.sponsors), function(sponsor, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('md-input-container', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("Név")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (sponsor.name),
        callback: function($$v) {
          _vm.$set(sponsor, "name", $$v)
        },
        expression: "sponsor.name"
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("Weboldal")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (sponsor.website),
        callback: function($$v) {
          _vm.$set(sponsor, "website", $$v)
        },
        expression: "sponsor.website"
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("Kép")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (sponsor.image),
        callback: function($$v) {
          _vm.$set(sponsor, "image", $$v)
        },
        expression: "sponsor.image"
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("Kategória")]), _vm._v(" "), _c('md-select', {
      model: {
        value: (_vm.form.sponsors[index].category),
        callback: function($$v) {
          _vm.$set(_vm.form.sponsors[index], "category", $$v)
        },
        expression: "form.sponsors[index].category"
      }
    }, _vm._l((_vm.sponsorCategories), function(sponsorCategory) {
      return _c('md-option', {
        attrs: {
          "value": sponsorCategory.value
        }
      }, [_vm._v(_vm._s(sponsorCategory.label))])
    }))], 1), _vm._v(" "), _c('a', {
      staticClass: "col-md-1",
      on: {
        "click": function($event) {
          _vm.removeStuff('sponsors', sponsor)
        }
      }
    }, [_c('md-icon', [_vm._v("remove_circle_outline")])], 1)], 1)
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.newSponsor($event)
      }
    }
  }, [_vm._v("Szponzor hozzáadása")])], 2), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h4', [_vm._v("Helyszínek")]), _vm._v(" "), _vm._l((_vm.locations), function(location, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('md-input-container', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("Név")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (location.name),
        callback: function($$v) {
          _vm.$set(location, "name", $$v)
        },
        expression: "location.name"
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md-2"
    }, [_c('label', [_vm._v("Hosszúság")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (location.latitude),
        callback: function($$v) {
          _vm.$set(location, "latitude", $$v)
        },
        expression: "location.latitude"
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md-2"
    }, [_c('label', [_vm._v("Szélesség")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (location.longitude),
        callback: function($$v) {
          _vm.$set(location, "longitude", $$v)
        },
        expression: "location.longitude"
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("Cím")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (location.address),
        callback: function($$v) {
          _vm.$set(location, "address", $$v)
        },
        expression: "location.address"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "col-md-1",
      on: {
        "click": function($event) {
          _vm.removeLocation(location, index)
        }
      }
    }, [_c('md-icon', [_vm._v("remove_circle_outline")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-12 row"
    }, [_c('a', {
      staticClass: "col-md-2",
      on: {
        "click": function($event) {
          _vm.loadCoords(location)
        }
      }
    }, [_vm._v("Koordináták kitöltése")]), _vm._v(" "), _c('a', {
      staticClass: "col-md-2",
      attrs: {
        "href": 'https://www.google.com/maps/?q=' + location.latitude + ',' + location.longitude,
        "target": "_blank"
      }
    }, [_vm._v("Megtekintés térképen")])])], 1)
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.newLocation($event)
      }
    }
  }, [_vm._v("Helyszín hozzáadása")])], 2), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Mentés")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('h3', [_vm._v("Szerkesztő")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f36df47!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/InformationView.vue
// module id = 556
// module chunks = 2